import { Stack } from '@startuptools/ui/Stack';
import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/joy/Button';
import { Controller } from 'react-hook-form';
import { FormControl } from '@startuptools/ui/joy/FormControl';
import { FormLabel } from '@startuptools/ui/joy/FormLabel';
import { StepProps } from '../../types';
import { Alert } from '@startuptools/ui/joy/Alert';
import { Select } from '@startuptools/ui/joy/Select';
import { Option } from '@startuptools/ui/joy/Option';
import { seats } from '../../../../common/seats';

const normalizeSeat = (seat: string | undefined | null) => {
  switch (seat) {
    case 'Stockholm kommun':
      return 'Stockholms kommun';
    default:
      return seat;
  }
};

export const StepSeat = ({ form, onSave, loading }: StepProps) => {
  return (
    <form onSubmit={form.handleSubmit(data => onSave({ seat: data.seat }))}>
      <Stack gap={2}>
        <Alert
          expandContent={
            <Trans id="Normally it is of very little importance where the company has its main location. Usually nobody follows up wether you actually hold you shareholder meeting in the main location. Sometimes it can be a requirement from issuers of public grants, for example when the support is from regional authorities." />
          }
        >
          <Trans id="Main location is normally the city where the company has its headquarters and the shareholder meeting should be held here." />
        </Alert>
        <Controller
          control={form.control}
          name="seat"
          key="seat"
          render={({ field }) => (
            <FormControl sx={{ alignItems: 'flex-start' }}>
              <FormLabel>
                <Trans id="Main location" />
              </FormLabel>
              <Select
                sx={{ maxWidth: '300px' }}
                onChange={(_, value) => {
                  if (value) field.onChange(value);
                }}
                value={normalizeSeat(field.value) ?? ''}
              >
                {seats.map(seat => (
                  <Option key={seat} value={seat}>
                    {seat}
                  </Option>
                ))}
              </Select>
            </FormControl>
          )}
        />
        <Stack direction="row" justifyContent="flex-start">
          <Button type="submit" loading={loading}>
            <Trans id="Next" />
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
